import { render, staticRenderFns } from "./InheritanceClaimPage.vue?vue&type=template&id=610c6336&scoped=true"
import script from "./InheritanceClaimPage.vue?vue&type=script&lang=js"
export * from "./InheritanceClaimPage.vue?vue&type=script&lang=js"
import style0 from "./InheritanceClaimPage.vue?vue&type=style&index=0&id=610c6336&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610c6336",
  null
  
)

export default component.exports